import Modal from '../../components/Modal';
function ProjectModal({
  open,
  onClose,
  title,
  onSubmit,
  projectForm,
  setProjectForm,
  availableProjectCabinets,
  toggleProjectCabinet,
  getUserLabel,
  setActiveSection,
  setSettingsTab,
  busy,
  projectEditId,
  onDelete,
  currentUserId
}) {
  const isOwner = projectEditId && projectForm?.ownerUserId === currentUserId;
  const handleDelete = () => {
    if (window.confirm('Вы уверены, что хотите удалить этот проект? Это действие нельзя отменить.')) {
      onDelete(projectEditId);
      onClose();
    }
  };
  if (!open) return null;
  return <Modal open onClose={onClose} title={title} wide>
            <form className="tasks__form" onSubmit={onSubmit}>
                <div className="tasks__layout">
                    <div className="tasks__section">
                        <label>
                            Название
                            <input type="text" value={projectForm.name} onChange={event => setProjectForm({
              ...projectForm,
              name: event.target.value
            })} />
                        </label>
                        <label>
                            Описание
                            <textarea rows={6} value={projectForm.description} onChange={event => setProjectForm({
              ...projectForm,
              description: event.target.value
            })} />
                        </label>
                    </div>
                    <div className="tasks__section">
                        <h4>Магазины в проекте</h4>
                        <div className="tasks__pick tasks__pick--scroll tasks__options">
                            {availableProjectCabinets.length === 0 ? <div className="empty">Нет доступных кабинетов.</div> : availableProjectCabinets.map(item => <button key={item.id} type="button" className={`tasks__option ${projectForm.cabinetIds.includes(item.id) ? 'active' : ''}`} onClick={() => toggleProjectCabinet(item.id)}>
                                        {item.account_name}
                                    </button>)}
                        </div>
                        <button type="button" className="ghost" onClick={() => {
            onClose();
            setActiveSection('settings');
            setSettingsTab('cabinets');
          }}>
                            Добавить магазины
                        </button>
                    </div>
                </div>
                <div className="tasks__actions">
                    <button type="button" className="ghost" onClick={onClose}>
                        Отмена
                    </button>
                    {isOwner && <button type="button" className="ghost danger" onClick={handleDelete}>
                            Удалить
                        </button>}
                    <button type="submit" disabled={busy}>
                        Сохранить
                    </button>
                </div>
            </form>
        </Modal>;
}
export default ProjectModal;
